// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__17-wx","header":"Messages_header__2LHhT"};